import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { AppLocale } from "@akina/infra";

type LocaleStore = {
  locale: AppLocale;
  setLocale: (newLocale: AppLocale) => void;
}

const getLocaleFromNavigator = (): AppLocale => {
  try {
    const l = navigator?.language;
    if (l === "en") return "en-CH";
    return l as AppLocale;
  } catch {
    return "en-CH";
  }
};

const parseDefaultLocale = (locale: AppLocale): AppLocale => {
  if (locale.startsWith("en")) return "en-CH";
  if (locale.startsWith("de")) return "de";
  if (locale.startsWith("fr")) return "fr";
  if (locale.startsWith("it")) return "it";
  return "en-CH";
};

const DEFAULT_LANGUAGE: AppLocale = getLocaleFromNavigator();
const PARSED_DEFAULT_LANGUAGE = parseDefaultLocale(DEFAULT_LANGUAGE);

export const useLocaleStore = create<LocaleStore>()(
  persist(
    set => ({
      locale: PARSED_DEFAULT_LANGUAGE,
      setLocale: (newLocale: AppLocale) =>
        set({
          locale: newLocale,
        }),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      version: 2,
      name: "locale",
    },
  ),
);
